import React from "react";
import cx from "classnames";

function checkMarkSize(size) {
  if (size === "sm") {
    return {
      width: "8px",
      height: "10px",
    };
  }

  if (size === "lg") {
    return {
      width: "12px",
      height: "14px",
    };
  }

  return {
    width: "10px",
    height: "12px",
  };
}

export default function Checkbox({
  label,
  name,
  id,
  checked,
  onChange,
  className,
  disabled = false,
  inline = false,
  size,
}) {
  return (
    <label
      htmlFor={id ? id : name}
      className={cx({
        "inline-block": inline,
        "block pb-3": !inline,
        [`${className}`]: className !== undefined,
        "relative text-left cursor-pointer font-normal": true,
        "text-sm leading-4 pl-6": size === "sm",
        "text-base leading-6 pl-8": size === "lg",
        "leading-5 pl-7": !size,
      })}
    >
      <input
        aria-checked={checked}
        type="checkbox"
        className="absolute -z-1 opacity-0"
        name={name}
        id={id ? id : name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        readOnly={!onChange ? true : undefined}
      />
      {label}
      <span
        className={cx(
          "flex justify-center items-center absolute left-0 top-0 border border-gray-500 rounded-sm",
          {
            "h-5 w-5": !size,
            "h-4 w-4": size === "sm",
            "h-6 w-6": size === "lg",
            "bg-main border-main": checked,
          }
        )}
      >
        {checked && (
          <svg viewBox="0 0 11 8" {...checkMarkSize(size)}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g
                transform="translate(-146.000000, -536.000000)"
                fill="#fff"
                fillRule="nonzero"
              >
                <path d="M149.641838,543.838864 L146.157021,540.354047 C145.94766,540.144686 145.94766,539.80523 146.157021,539.595848 L146.915199,538.837649 C147.12456,538.628267 147.464037,538.628267 147.673398,538.837649 L150.020937,541.185168 L155.049105,536.157021 C155.258466,535.94766 155.597942,535.94766 155.807304,536.157021 L156.565482,536.91522 C156.774843,537.124581 156.774843,537.464037 156.565482,537.673419 L150.400037,543.838885 C150.190654,544.048246 149.851199,544.048246 149.641838,543.838864 Z" />
              </g>
            </g>
          </svg>
        )}
      </span>
    </label>
  );
}
